// 用来存放axios请求
import axios from 'axios';
import qs from 'qs'

// 定义服务转发的路径映射（服务名称，请求路径（不以/开头））
const serverProxy = (serverName, queryPath) => `/${serverName}/${queryPath}`
// 全局定义一个存放取消请求的标识
window.axiosCancel = {}

const service = axios.create({
  // baseURL:  '/',
  baseURL: process.env.NODE_ENV === 'production' ? 'https://website-api-sea.galasports.com' : '/api',
  // baseURL: process.env.NODE_ENV === 'production' ? '/' : '/api',
  timeout: 360000, // 请求超时时间
  headers: {
    "X-Requested-With": "XMLHttpRequest",
    'Content-Type': 'application/json'
  },
  withCredentials: true //跨域配置(针对不同端口)
});

const request = (urlOrOptions, data = null, method = 'get', jsonFormat = false) => {
  let conf = {}
  if (Object.prototype.toString.call(urlOrOptions) === '[object Object]') {
    conf = { ...urlOrOptions }
  } else if (Object.prototype.toString.call(urlOrOptions) === '[object String]') {
    conf = {
      url: urlOrOptions,
      method: method
    }

    if (method.toLowerCase() === 'get') {
      conf.params = data
    } else {
      conf.data = jsonFormat ? data : qs.stringify(data)
    }

    if (!jsonFormat) {
      conf.headers = {
        ...conf.headers
      }
    }
  } else {
    throw new Error('request arguments error. required String url or Object options. but: ' + urlOrOptions)
  }
  // 系统转发（对于url格式为: [serverName]/path 的路径）
  if (/\[.+].*/.test(conf.url)) {
    let query = conf.url.substring(conf.url.indexOf(']') + 1)
    if (query.startsWith('/')) {
      query = query.substring(1)
    }
    const appName = conf.url.substring(1, conf.url.indexOf(']'))
    conf.url = serverProxy(appName, query)
    // console.log(url)
  }
  return service(conf)
}

export default request;
